import { render, staticRenderFns } from "./link-collapse-transition.vue?vue&type=template&id=0bc14162&"
import script from "./link-collapse-transition.vue?vue&type=script&lang=js&"
export * from "./link-collapse-transition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports